export const BUSINESS_TYPES = {
  CORPORATION: '1',
  INDIVIDUAL: '2',
};
